import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=98f681dc&scoped=true"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"
import style0 from "./ModalAlert.vue?vue&type=style&index=0&id=98f681dc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f681dc",
  null
  
)

export default component.exports